// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__314Na","placeholdersHeader":"styles_placeholdersHeader__1UX3h","editorStyle":"styles_editorStyle__27KV3","placeholdersBox":"styles_placeholdersBox__2wGp4"};